var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"dialog_diy",attrs:{"title":"素材库","visible":_vm.show,"append-to-body":true,"width":"100%","before-close":_vm.handleClose}},[_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('fileBox',{ref:"fileBoxRef",attrs:{"type":"2"},on:{"addFile":_vm.addFile}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d2630a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/classroomObservation/components/resourceLibraryDialog.vue
// module id = null
// module chunks = 